import { useCallback, useEffect } from "react";
import { useRefresh } from "react-admin";
import { useSelector } from "react-redux";
import { HosDriverDto } from "../data/service-proxies";
import { AppState } from "../types";
import { useSelectedTenant } from "./useSelectedTenant";

export const useFleetManagerHubHosUpdates = (driverId: number | undefined) => {
  const refresh = useRefresh();
  const { hub } = useSelector((x: AppState) => x.fleetManagerHub);
  const { tenantId } = useSelectedTenant();

  const handleHosData = useCallback(
    (data: HosDriverDto) => {
      refresh();
    },
    [refresh]
  );

  useEffect(() => {
    if (!hub) {
      return;
    }

    if (!driverId) {
      return;
    }

    hub.invoke("SubscribeToDriver", { tenantId, driverId });
    hub.on("onHosDataRefreshed", handleHosData);
    return () => {
      hub.off("onHosDataRefreshed");
      hub.invoke("UnsubscribeFromDriver", { tenantId, driverId });
    };
  }, [hub, handleHosData, tenantId, driverId]);
};
